// react
import React, {useEffect, useState} from 'react'
import {Select,Button, Drawer, Space, Table} from 'antd'
import type { SelectProps } from 'antd';
import Api from '@/api'
import dayjs from 'dayjs'
import FlowLogDetail from '@/pages/company/logs/detail'
import {EmptyPanel} from '@/components/elements'
import FlowTaskDetailLogs from '@/pages/company/logs/stepDetail'

interface IProps {
  flowId: string
  close: () => void
}

interface IQueryEn {
  current: number
  size: number
  flowId: string
  createMonth: String  //规则：yyyyMM，示例值：202312
}

/**
 * 流程日志
 * @constructor
 */
const FlowLogs = (props: IProps) => {



  const [TableData, setTableData] = useState<any>()
  const [Loading, setLoading] = useState<boolean>(false)
  const [Total, setTotal] = useState<number>(0)
  const [DetailStr, setDetailStr] = useState<string>("")
  const [TaskId, setTaskId] = useState<string>("")
  const [DetailId, setDetailId] = useState<string>("")

  const defaultCerateMonthStr = dayjs().format('YYYYMM')
  const defaultCerateMonthOption = {label:defaultCerateMonthStr,value:defaultCerateMonthStr}
  const [CreateMonthOptions, setCreateMonthOptions] = useState<SelectProps['options']>([defaultCerateMonthOption])
  const [CreateMonth, setCreateMonth] = useState<string>(defaultCerateMonthStr)

  const [Open, setOpen] = useState<boolean>(true)
  const [Query, setQuery] = useState<IQueryEn>({
    current: 1,
    size: 10,
    flowId: props.flowId,
    createMonth: CreateMonth
  })

    /**
   * 日志月份选择下拉列表数据
   */
  const getCreateMonthOptions = async () => {
    //setLoading(true)
    const _data: any = await Api.Company.FlowLogCreateMonthList({"flowId": props.flowId})

    let records: any = []
    
    _data.map((d) => {
      records.push({
          value: d,
          label: d
      })
    })
    setCreateMonthOptions(records)
  }

  /**
   * 列表
   */
  const getList = async () => {
    setLoading(true)
    const _data: any = await Api.Company.FlowLogList(Query).finally(() => setLoading(false))
    if (_data) {
      setTableData(_data.records)
      setTotal(_data.total)
    }
  }

    /**
   * 详情
  */
  const requestlogs = async (flowId, createMonth, logId) => {
    setLoading(true)
    const _data: any = await Api.Company.FlowLogById({"flowId":flowId, "createMonth":createMonth, "id":logId}).finally(() => setLoading(false))
    if (_data) {
      console.log(_data)
      setDetailStr(_data.detail)
      setDetailId(logId)
    }
  }

  useEffect(() => {
    props.flowId && getList()
  }, [props.flowId, Query])


  /**
   * 关闭
   */
  const close = () => {
    setOpen(false)
    const _timeOut = setTimeout(() => {
      props.close()
      clearTimeout(_timeOut)
    }, 500)
  }

    const handleCreateMonthChange = (newValue: string) => {
    Query.createMonth = newValue;
    setCreateMonth(newValue);
  };

    const refreshList = () => {
    setQuery({
      ...Query,
      current: 1
    })
  }

  const columns: any = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: 'Flow_ID',
      key: 'flowId',
      dataIndex: 'flowId',
    },{
      title: 'Task_ID',
      key: 'taskId',
      dataIndex: 'taskId',
    },
    {
      title: '状态',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      render: (text: string, record: any) => (
        <>
          {JSON.parse(record.detail)?.executeResp.code == 1 ? '失败' : '成功'}
        </>
      ),
    },
    {
      title: '操作人',
      dataIndex: 'operatorName',
      key: 'operatorName',
      width: 100,
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text: string) => (
        <>
          {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
        </>
      ),
    },
    {
      title: '操作',
      key: 'address',
      width: 180,
      render: (text: string, record: any, index: number) => (
        <>
          <Space size="middle">
            <a type="text" onClick={() => {
              setTaskId(record.taskId)
            }}>
              执行详情
            </a>
            <a type="text" onClick={() => {
              requestlogs(props.flowId, dayjs(record.createTime).format('YYYYMM'), record.id)
            }}>
              日志详情
            </a>
          </Space>
        </>
      ),
    },
  ]

  return (
    <Drawer
      open={Open}
      onClose={() => close()}
      destroyOnClose
      keyboard={false}
      width={"100%"}
      title={"流程日志"}
      extra={
         <Space>
         <Select
            //mode="multiple"
            //disabled
            value={CreateMonth}
            style={{ width: 120 }}
            placeholder="Please select"
            defaultValue={''}
            onChange={handleCreateMonthChange}
            options={(CreateMonthOptions || []).map((d) => ({
              value: d.value,
              label: d.text,
            }))}
          />
           <Button onClick={refreshList}>刷新</Button>
        </Space>
      }
    >
      {DetailStr && <FlowLogDetail flowId={props.flowId} createMonth={CreateMonth} id={DetailId} json={DetailStr} close={() => setDetailStr("")}/>}
      {TaskId && <FlowTaskDetailLogs flowId={props.flowId} createMonth={CreateMonth} taskId={TaskId} close={() => setTaskId("")}/>}
      <Table
        dataSource={TableData}
        loading={Loading}
        bordered
        rowKey={(row) => row.id}
        size={'small'}
        columns={columns}
        locale={{
          emptyText: <EmptyPanel description={"暂无数据"}/>,
        }}
        pagination={{
          current: Query.current,
          pageSize: Query.size,
          total: Total,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]}, 共 ${total} 条`,
          onChange: (page, pageSize) => {
            setQuery({
              ...Query,
              current: page,
              size: pageSize
            })
          }
        }}
      />
    </Drawer>
  )
}

export default FlowLogs
